import { forwardRef, type PropsWithChildren } from "react";

import clsx from "clsx";

import { Button, type ButtonProps } from "./button";

export interface QuickSelectNoticeButtonProps
  extends Omit<ButtonProps, "variant"> {
  selected?: boolean;
}

export const QuickSelectNoticeButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<QuickSelectNoticeButtonProps>
>(({ selected, className, children, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      variant="quick-select"
      className={clsx(
        "text-v2-secondary",
        "hover:bg-v2-highlight-notice hover:border-v2-action-positive hover:text-v2-action-positive",
        "focus:border-v2-action-positive active:border-v2-action-positive",
        "focus:bg-v2-highlight-notice focus:font-semibold active:bg-v2-highlight-notice active:font-semibold",
        {
          "font-semibold border-v2-action-positive bg-v2-highlight-notice text-v2-action-positive":
            selected,
          "shadow-[inset_2px_2px_2px] shadow-v2-black/10%": selected,
          "hover:border-v2-action-positive hover:bg-v2-highlight-notice":
            selected,
        },
        className,
      )}
      {...props}
    >
      {children}
    </Button>
  );
});
